var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-behind-indicators",style:(_vm.containerStyle)},_vm._l((_vm.indicatorsByDate),function(item,index){return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
      content: _vm.getTooltipHTML(item),
      html: true,
      placement: 'auto',
      classes: 'otp-tooltip',
      trigger: 'hover',
    }),expression:"{\n      content: getTooltipHTML(item),\n      html: true,\n      placement: 'auto',\n      classes: 'otp-tooltip',\n      trigger: 'hover',\n    }"}],key:index,staticClass:"indicator-dot",style:(_vm.getDotStyle(item))},[_vm._v(" "+_vm._s(item.count)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }